/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Card from '../component/Card/Card';
import {
  EditContainer,
  PageContainer,
  PageContent,
} from '../component/Containers/Containers';
import { setIsLoadingTo } from '../store/features/adminSlice';
import { HttpListClient } from '../utils/HttpClient';

/**
 * @component
 *  returns the edit view and connects to the station api
 * allows modification of a station that was clicked on.
 * @returns {void}
 */
const Edit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const { allStations, provinceIdMap } = useSelector((state) => state.stations);
  const [currentStation, setCurrentStation] = useState();
  const [provinces, setProvinces] = useState([]);
  const GET_PROVINCES_URL = '/getProvinces';
  const { isLoading } = useSelector((state) => state.admin);

  /**
   * useEffect that returns the station by an ID passed as a route parameter
   * if no station is found, it will return to the previous page.
   * @returns {void}
   */
  useEffect(async () => {
    dispatch(setIsLoadingTo(true));
    let station = allStations.filter((station) => station.Id == id)[0];
    setCurrentStation(station);
    station ?? history.goBack();
    let fetchedProvinces = await HttpListClient.get(GET_PROVINCES_URL);
    setProvinces(fetchedProvinces?.data);
    dispatch(setIsLoadingTo(false));
  }, []);

  useEffect(async () => {}, []);

  return (
    <PageContainer>
      <PageContent>
        {isLoading ? null : (
          <EditContainer style={{ marginRight: '30px' }}>
            <div
              style={{
                width: '90%',
                alignSelf: 'center',
                justifySelf: 'center',
                display: 'flex',
                justifyContent: 'center',
              }}>
              {currentStation ? (
                <Card provinces={provinces} station={currentStation} />
              ) : null}
            </div>
          </EditContainer>
        )}
      </PageContent>
    </PageContainer>
  );
};

export default Edit;
